<!-- 出入库报表（收发存台账） -->
<template>
    <div style="background-color: white; height: calc(100vh - 84px); display: flex; flex-direction: column;">
        <el-form class="demo-form-inline" :inline="true" ref="stockLedgerForm" :model="stockLedgerForm"
        size="mini" label-width="100px">
            <el-form-item label="仓库" prop="ckName">
                <el-select placeholder="请选择仓库" v-model="stockLedgerForm.ckName">
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否保税" prop="isBonded">
                <el-select placeholder="请选择" v-model="stockLedgerForm.isBonded" clearable>
                    <el-option v-for="item in bondedTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提单号" prop="blNo">
                <el-input v-model="stockLedgerForm.blNo" placeholder="请输入提单号" clearable style="width: 100%;" ></el-input>
            </el-form-item>
            <el-form-item label="货物名称" prop="goodsName">
                <el-select filterable :default-first-option="true" remote :remote-method="getGoodsList"
                    placeholder="请选择货物名称" v-model="stockLedgerForm.goodsName" clearable>
                    <el-option v-for="item in goodsList" :key="item.id" :label="item.goodsName" :value="item.goodsName">
                        <span class="margin_right_20">{{ item.goodsType }}</span> 
                        <span class="margin_right_20">{{ item.goodsName }}</span>
                        <span >{{ item.hsCode }}</span> 
                    </el-option>
                </el-select>
                <!-- <el-input v-model="stockLedgerForm.goodsName" placeholder="请输入货物名称" clearable style="width: 100%;"></el-input> -->
            </el-form-item>
            <el-form-item label="海关编码" prop="hsCode">
                <el-input v-model="stockLedgerForm.hsCode" placeholder="请输入海关编码" clearable style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="报关单号" prop="cusDeclNo">
                <el-input v-model="stockLedgerForm.cusDeclNo" placeholder="请输入报关单号" clearable style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="核注清单号" prop="invDecNo">
                <el-input v-model="stockLedgerForm.invDecNo" placeholder="请输入核注清单号" clearable style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="账册号" prop="handbook">
                <el-input v-model="stockLedgerForm.handbook" placeholder="请输入账册号" clearable style="width: 100%;"></el-input>
            </el-form-item>
             <el-form-item label="日期范围" prop="date">
                <el-date-picker v-model="stockLedgerForm.date" type="daterange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    :picker-options="pickerOptions" @change="changeDate" style="width: 250px">
                </el-date-picker>
                <span style="color: #909399; font-size: 12px; margin-left: 6px;">最多一个月</span>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="wmsGetStockLedger">搜索</el-button>
                <el-button type="primary" @click="stockLedgerExport">导出</el-button>
            </el-form-item>
        </el-form>
        <div style="flex: 1; overflow: hidden;">
            <vxe-table id="stockLedgerTable" size="mini" ref="stockLedgerTable" :data="stockLedgerList"
            border stripe header-align="center" max-height="100%" show-overflow show-header-overflow
            :row-config="{ isCurrent: true, isHover: true }">
                <vxe-column type="seq" title="序号" width="60"></vxe-column>
                <vxe-column field="ckName" title="仓库" width="140"></vxe-column>
                <vxe-column field="isBonded" title="保税类型" width="90"></vxe-column>
                <vxe-column field="ownerName" title="货主" min-width="200"></vxe-column>
                <vxe-column field="blNo" title="提单号" min-width="160"></vxe-column>
                <vxe-column field="handbook" title="账册号" min-width="160"></vxe-column>
                <vxe-column field="itemNo" title="项号" width="80"></vxe-column>
                <vxe-column field="goodsName" title="货物名称" min-width="220"></vxe-column>
                <vxe-column field="spec" title="规格型号" min-width="200"></vxe-column>
                <vxe-column field="hsCode" title="海关编码" width="140"></vxe-column>
                <vxe-colgroup title="期初结存">
                    <vxe-column field="beginQty1" title="数量" width="110" align="right"></vxe-column>
                    <vxe-column field="beginNetWeight" title="净重(吨)" width="120" align="right"></vxe-column>
                </vxe-colgroup>
                <vxe-colgroup title="入库">
                    <vxe-column field="inQty1" title="数量" width="110" align="right"></vxe-column>
                    <vxe-column field="inNetWeight" title="净重(吨)" width="120" align="right"></vxe-column>
                </vxe-colgroup>
                <vxe-colgroup title="出库">
                    <vxe-column field="outQty1" title="数量" width="110" align="right"></vxe-column>
                    <vxe-column field="outNetWeight" title="净重(吨)" width="120" align="right"></vxe-column>
                </vxe-colgroup>
                <vxe-colgroup title="结存">
                    <vxe-column field="endQty1" title="数量" width="110" align="right"></vxe-column>
                    <vxe-column field="endNetWeight" title="净重(吨)" width="120" align="right"></vxe-column>
                </vxe-colgroup>
                <vxe-column field="decPrice" title="报关单价" width="110" align="right"></vxe-column>
                <vxe-column field="decAmount" title="报关金额" width="130" align="right"></vxe-column>
            </vxe-table>
        </div>
    </div>
</template>
<script>
import ExcelJS from 'exceljs';
import userProfile from '@/mixins/userProfile.js'
import clean from 'lodash-clean';

export default {
    name: 'inboundReport',
    mixins: [userProfile],
    components: {

    },
    watch: {

    },
    data() {
        return {
            stockLedgerForm: {
                ckName: "",
                isBonded: "",
                date: "",
                startDate: "",
                endDate: "",
                blNo: "",
                goodsName: "",
                hsCode: "",
                cusDeclNo: "",
                invDecNo: "",
                handbook: "",
            },
            stockLedgerList: [],
            ckNameList: [], // 仓库列表
            goodsList:[], // 货物列表
            bondedTypeList: [], // 保税属性列表
            pickerMinDate: "", // 日期选择器第一次点选的日期，用来限制最多只能选一个月
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }],
                onPick: ({ maxDate, minDate }) => {
                    this.pickerMinDate = minDate ? new Date(minDate.getTime()) : ''
                    // 首尾日期都选完了，解除限制
                    if (maxDate) {
                        this.pickerMinDate = ''
                    }
                },
                disabledDate: (time) => {
                    // 不能查未来日期
                    const today = new Date();
                    today.setHours(23, 59, 59, 999);
                    if (time.getTime() > today.getTime()) {
                        return true;
                    }
                    // 选了开始日期后，只允许开始日期 ~ 开始日期往后一个月
                    if (!this.pickerMinDate) {
                        return false;
                    }
                    const startTime = this.pickerMinDate.getTime();
                    const maxTime = this.addOneMonth(this.pickerMinDate).getTime();
                    return time.getTime() < startTime || time.getTime() > maxTime;
                }
            },
        }
    },
    async created() {
        // 默认查询最近一周（接口没分页，日期范围最多一个月）
        const endDateObj = new Date()
        const startDateObj = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
        this.stockLedgerForm.date = [startDateObj, endDateObj]
        this.stockLedgerForm.startDate = this.formatDate(startDateObj)
        this.stockLedgerForm.endDate = this.formatDate(endDateObj)
        await this.getckNameList()
        await this.getIsBonded()
        await this.wmsGetStockLedger()  
    },
    mounted() {

    },
    methods: {
        // 日期转换
        formatDate(dateObj) {
            if (!dateObj) return ''
            const date = new Date(dateObj)
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        },
        // 日期往后推一个月
        addOneMonth(dateObj) {
            const date = new Date(dateObj.getTime())
            date.setMonth(date.getMonth() + 1)
            return date
        },
        // 日期范围是否超过一个月
        isOverOneMonth(startDateObj, endDateObj) {
            return endDateObj.getTime() > this.addOneMonth(startDateObj).getTime()
        },
        // 日期选择后格式化查询参数
        changeDate(value) {
            if (!value || value.length !== 2 || !value[0] || !value[1]) {
                this.stockLedgerForm.startDate = ''
                this.stockLedgerForm.endDate = ''
                this.pickerMinDate = ''
                return
            }
            const startDateObj = value[0]
            const endDateObj = value[1]
            if (this.isOverOneMonth(startDateObj, endDateObj)) {
                this.$message.warning('日期范围最多只能选择一个月，请重新选择')
                this.pickerMinDate = ''
                this.stockLedgerForm.date = []
                this.stockLedgerForm.startDate = ''
                this.stockLedgerForm.endDate = ''
                return
            }
            this.stockLedgerForm.startDate = this.formatDate(startDateObj)
            this.stockLedgerForm.endDate = this.formatDate(endDateObj)
        },
        // 获取货物计划列表
        getGoodsList(value){
            this.$api.wmsgetListBy( 1,100,{param:value} ).then(res =>{
                this.goodsList = res.tableData
            })
        }, 
        // 获取数据（接口无分页，日期范围最多一个月，空值条件不传）
        wmsGetStockLedger() {
            if (!this.stockLedgerForm.startDate || !this.stockLedgerForm.endDate) {
                this.$message.warning('请先选择日期范围')
                return
            }
            const params = clean({
                ckName: this.stockLedgerForm.ckName,
                isBonded: this.stockLedgerForm.isBonded,
                blNo: this.stockLedgerForm.blNo,
                goodsName: this.stockLedgerForm.goodsName,
                hsCode: this.stockLedgerForm.hsCode,
                cusDeclNo: this.stockLedgerForm.cusDeclNo,
                invDecNo: this.stockLedgerForm.invDecNo,
                handbook: this.stockLedgerForm.handbook,
                startDate: this.stockLedgerForm.startDate,
                endDate: this.stockLedgerForm.endDate,
            })
            return this.$api.wmsGetStockLedger(params).then(res => {
                this.stockLedgerList = res || []
            })
        },
        // 获取仓库
        getckNameList() {
            return this.$api.getCkNamesBy().then(res => {
                this.ckNameList = res
                this.stockLedgerForm.ckName = this.ckNameList[0]
            })
        },
        // 获取保税属性
        getIsBonded() {
            return this.$api.getDicList({ value: 'Wms保税属性' }).then(res => {
                this.bondedTypeList = res || []
            })
        },
        // 导出（导出当前查询出来的数据）
        async stockLedgerExport() {
            if (!this.stockLedgerList || this.stockLedgerList.length === 0) {
                this.$message.warning('没有可导出的数据，请先查询')
                return
            }
            const columnTitles = [
                '序号', '仓库', '保税类型', '货主', '账册号', '提单号', '项号', '货物名称', '规格型号', '海关编码',
                '期初数量', '期初净重(吨)', '入库数量', '入库净重(吨)', '出库数量', '出库净重(吨)',
                '结存数量', '结存净重(吨)', '报关单价', '报关金额'
            ]
            const columnKeys = [
                'seq', 'ckName', 'isBonded', 'ownerName', 'handbook', 'blNo', 'itemNo', 'goodsName', 'spec', 'hsCode',
                'beginQty1', 'beginNetWeight', 'inQty1', 'inNetWeight', 'outQty1', 'outNetWeight',
                'endQty1', 'endNetWeight', 'decPrice', 'decAmount'
            ]
            // 数值列，导出成数字方便在excel里求和
            const numberKeys = [
                'beginQty1', 'beginNetWeight', 'inQty1', 'inNetWeight', 'outQty1', 'outNetWeight',
                'endQty1', 'endNetWeight', 'decPrice', 'decAmount'
            ]
            const columnWidths = [8, 14, 10, 26, 18, 18, 8, 26, 24, 16, 12, 14, 12, 14, 12, 14, 12, 14, 12, 14]
            const ckName = this.stockLedgerForm.ckName || '全部仓库'

            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet('出入库报表')
            const lastColName = worksheet.getColumn(columnTitles.length).letter

            const allBorder = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }

            // 标题
            const titleRow = worksheet.addRow([ckName + '出入库报表'])
            worksheet.mergeCells(`A1:${lastColName}1`)
            titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' }
            titleRow.getCell(1).font = { bold: true, size: 16 }
            titleRow.height = 30

            // 查询条件
            const infoRow = worksheet.addRow([
                `日期范围：${this.stockLedgerForm.startDate} 至 ${this.stockLedgerForm.endDate}　　保税类型：${this.stockLedgerForm.isBonded || '全部'}`
            ])
            worksheet.mergeCells(`A2:${lastColName}2`)
            infoRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' }
            infoRow.getCell(1).font = { bold: true, size: 12 }
            infoRow.height = 20

            // 表头
            const headerRow = worksheet.addRow(columnTitles)
            headerRow.eachCell((cell) => {
                cell.font = { bold: true }
                cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true }
                cell.border = allBorder
            })
            headerRow.height = 24

            // 数据
            this.stockLedgerList.forEach((item, index) => {
                const rowData = columnKeys.map(key => {
                    if (key === 'seq') {
                        return index + 1
                    }
                    const value = item[key]
                    if (value === null || value === undefined) {
                        return ''
                    }
                    if (numberKeys.indexOf(key) > -1) {
                        const num = Number(value)
                        return isNaN(num) ? value : num
                    }
                    return value
                })
                const dataRow = worksheet.addRow(rowData)
                dataRow.height = 20
                dataRow.eachCell((cell) => {
                    cell.border = allBorder
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: false }
                })
            })

            // 列宽
            columnWidths.forEach((width, index) => {
                worksheet.getColumn(index + 1).width = width
            })

            const buffer = await workbook.xlsx.writeBuffer()
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = `${ckName}出入库报表_${this.stockLedgerForm.startDate}_${this.stockLedgerForm.endDate}.xlsx`
            link.click()
            window.URL.revokeObjectURL(url)
        },
    }
}
</script>
<style lang="less" scoped>
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
.margin_right_20{
    margin-right: 20px;
}
</style>
